import { t } from "@lingui/macro"

export const buildCruiseName = (departurePort: string, arrivalPort: string): string => {
    return `${departurePort} ${t`port-to-port`} ${arrivalPort}`
}
